import React from 'react';
import PropTypes from 'prop-types';
import ArcherTooltip from '../../archer-calculator/components/ArcherToolTip/ArcherTooltip';

const Input = (props) => {
    const handleChange = (e) => {
        if (props.onChange) {
            props.onChange(e.target.value); // Call the onChange prop with the new state
        }

    };
    return (
        <div className="form-item form-item--select ">
            <div className='input-label-wrapper'>
                <label htmlFor={props.id} className="form-item__label">
                    {props.label}
                </label>
                {props.tooltipContent &&
                    <ArcherTooltip content={props.tooltipContent} />
                }
            </div>
            <select id={props.id} onChange={handleChange} className="select__select " name="Select" >
                {props.children}
            </select>

        </div>
    );
};

Input.propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    showPleaseSelect: PropTypes.bool,
    children: PropTypes.array,
    onChange: PropTypes.func,
    tooltipContent: PropTypes.string
};

export default Input;
